import {
  QUESTION_SEPARATOR,
  PREDEFINED_NOT_APPLICABLE,
  PREDEFINED_PROVIDED_ELSEWHERE,
  PREDEFINED_ANSWERS_LIST,
} from '@/_constants/questions';

// @Lisia TODO: Merge this function with buildAnswerString in DocumentChecklist.tsx
export const addUploadedItem = (answer: string = '', item?: string): string => {
  if (!item) return answer;
  if (!answer) return item;

  let uploadedDocuments: Array<string> = answer?.split(QUESTION_SEPARATOR);

  if (uploadedDocuments.includes(item)) return answer;
  if (
    !!uploadedDocuments.length &&
    PREDEFINED_ANSWERS_LIST.some((predefinedAnswer) =>
      uploadedDocuments.includes(predefinedAnswer),
    )
  ) {
    // Remove the item if it's a predefined answer
    uploadedDocuments = uploadedDocuments.filter(
      (document) => !PREDEFINED_ANSWERS_LIST.includes(document as any),
    ) as Array<string>;
  }

  uploadedDocuments.push(item);

  if (uploadedDocuments.length === 1) {
    return QUESTION_SEPARATOR + item;
  } else {
    return uploadedDocuments.join(QUESTION_SEPARATOR);
  }
};

export const removeUploadedItem = (
  answer: string = '',
  item?: string,
): string => {
  if (!item) return answer;

  const split: Array<string> = answer
    ?.split(QUESTION_SEPARATOR)
    .filter((part) => part !== item);

  return split.join(QUESTION_SEPARATOR);
};

export const getUploadedItems = (answer: string = ''): Array<string> => {
  if (!answer) return [];

  const split: Array<string> = answer
    ?.split(QUESTION_SEPARATOR)
    ?.filter(
      (a) =>
        a !== PREDEFINED_NOT_APPLICABLE && a !== PREDEFINED_PROVIDED_ELSEWHERE,
    )
    ?.filter(Boolean);

  return split;
};

export const getShortUploadName = (fileName?: string): string => {
  const shortUploadAnswer: string =
    fileName?.split('/').pop() || fileName || '(empty)';

  return shortUploadAnswer;
};
